import { UndoRedoTypes } from "../utils/constants";
class StateHistory {
  busy = false;
  history = [];

  idx = -1;
  get canUndo() {
    return this.idx > 0;
  }
  get canRedo() {
    return this.idx < this.history.length - 1;
  }

  reset() {
    this.history = [];
    this.idx = -1;
  }

  async snapshot(action, type = null) {
    this.busy = true;

    this.history.splice(this.idx + 1);
    // if previous action is rangeSelection, we need to pop it
    if (this.history[this.history.length - 1]?.type === type && type == UndoRedoTypes.RangeSelection) {
      this.history.pop();
      this.idx--;
    }
    this.history.push({ ...action, type });
    this.idx++;

    await action.redo();

    this.busy = false;
  }

  async undo() {
    const innerUndo = async () => {
      if (!this.canUndo) return;
      this.busy = true;

      // if the type is rangeSelection run two actions
      await this.history[this.idx--].undo();

      this.busy = false;
    };
    if (this.history[this.idx]?.type === UndoRedoTypes.RangeSelection) await innerUndo();
    await innerUndo();
  }

  async redo() {
    const innerRedo = async () => {
      if (!this.canRedo) return;
      this.busy = true;

      await this.history[this.idx++].redo();
      this.busy = false;
    };
    if (this.history[this.idx]?.type === UndoRedoTypes.RangeSelection) await innerRedo();
    await innerRedo();
  }
}

export const stateHistory = new StateHistory();
